import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "light" }) {
  const { i18n, t } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) || SUPPORTED_LANGUAGES[0];

  const changeTo = (code) => {
    i18n.changeLanguage(code);
  };

  const toneBtn =
    variant === "dark"
      ? "text-white/80 hover:text-gold border border-white/10 hover:border-gold/40"
      : "text-slate-600 hover:text-petroleum border border-slate-200 hover:border-gold/40";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="button-language-switcher"
          aria-label={t("common.language")}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition ${toneBtn}`}
        >
          <Globe size={12} />
          <span className="tabular-nums">{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-slate-500">
          {t("common.language")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => changeTo(l.code)}
            data-testid={`button-lang-${l.code}`}
            className="cursor-pointer"
          >
            <span className="mr-2 text-base leading-none">{l.flag}</span>
            <span className="flex-1">{l.label}</span>
            {i18n.resolvedLanguage === l.code && <Check size={12} className="text-gold" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
